import {Record as record} from 'immutable';

export default record(
    {
        badges: [],
        byOwnerProperties: {},
        byOwnerPropertiesFetchFailed: false,
        byOwnerPropertiesFetchSuccess: false,
        propertyContentItems: [],
        recommendedProperties: {},
        recommendedPropertiesFetchSuccess: false,
        recommendedPropertiesFetchFailed: false,
        registrationNumber: '',
        unitSpaces: {},
        unitContentItems: [],
        unitMetadata: [],
        urgencyMessage: null,
        discoveryFeed: {},
        rankedBadges: [],
        geoRelativeDistances: null,
        description: null,
        localizedPropertyDescriptionMap: {}
    },
    'listingExtended'
);
